import { Container } from "@/components/atoms";
import { Breadcrumb } from "@/components/molecules";
import { legalDocs } from "@/content/legal";
import { Seo } from "@/components/seo";

export function LegalPage({ slug }: { slug: keyof typeof legalDocs }) {
  const doc = legalDocs[slug];
  return (
    <>
      {/* DRB-72 — no description here either; all four legal pages shared the generic one. */}
      <Seo
        title={doc.title}
        path={`/legal/${doc.slug}`}
        description={`${doc.title} for DrBurns’ ReLeaf.`}
      />
      <Container className="max-w-3xl py-12">
        <Breadcrumb
          items={[{ label: "Home", to: "/" }, { label: doc.title }]}
        />
        <h1 className="mt-4 font-condensed text-4xl font-bold text-night-blue">
          {doc.title}
        </h1>
        <p className="mt-1 text-sm text-night-blue/70">
          Last updated: {doc.updated}
        </p>
        <div className="mt-8 space-y-6">
          {doc.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-condensed text-xl font-bold text-night-blue">
                {s.heading}
              </h2>
              <p className="mt-1 text-night-blue/70">{s.body}</p>
            </section>
          ))}
        </div>
      </Container>
    </>
  );
}

export const Privacy = () => <LegalPage slug="privacy" />;
export const Terms = () => <LegalPage slug="terms" />;
export const Shipping = () => <LegalPage slug="shipping" />;
export const Returns = () => <LegalPage slug="returns" />;
export const Disclaimer = () => <LegalPage slug="disclaimer" />;
